module.exports = __webpack_public_path__ + "static/8-799ebdce448dd4e30aa7179130a30edf.jpg";